module.exports = __webpack_public_path__ + "static/2p-1-b6d574dc1d69f9c60c5d198e2b23fe46.jpeg";